import { CurriculumMappingQuizTask } from '../types/mapping-quiz.types'

export function calculateMappingQuizTotalPrerequisites(prerequisites: CurriculumMappingQuizTask[]): number {
  return prerequisites?.reduce((total, item) => total + item.subjectList.length, 0)
}

export const getStepTwoExpandedKey = (countryCode: string, gradeLevel: number, subjectOrder: number): string => {
  return `${countryCode}-${gradeLevel}-${subjectOrder}`
}

export function extractCountryCodeAndGradeIdFromUrl(url: string): {
  countryCode: string
  gradeLevel: number
  subjectOrder: number
} {
  const parts = url.split('/')
  const countryCode = parts[2]?.split('-')[1] || ''
  const gradeLevel = Number(parts[3])
  const subjectOrder = Number(parts[4])

  return { countryCode, gradeLevel, subjectOrder }
}

export const normalizeCountryCode = <T extends { countryCode: string }>(data: T): T => ({
  ...data,
  countryCode: data.countryCode === 'default' || data.countryCode === 'ua' ? 'us' : data.countryCode,
})
